/* eslint-disable eag/match-named-export */
import {createContext, TestIdProps, Nullish} from 'shared/web';

type ChoiceContext = TestIdProps & {
  hasOptionCheckbox?: boolean;
  'data-name'?: string;
  imageCache: Map<string, string | Nullish>;
  setImageCache: (optionId: string, imageUrl: string | Nullish) => void;
};

export const [ChoiceContextProvider, useChoice] = createContext<ChoiceContext>({
  strict: false,
  name: 'ChoiceContext',
});
